import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!

import { SalesLetterPage } from './pages/SalesLetterPage';
export function App() {
  return <SalesLetterPage data-id="element-0" />;
}